import React, { useState, useEffect } from "react";

import OrdersList from "./OrdersList/OrdersList.jsx";
import OrderDetail from "./OrderDetail/OrderDetail.jsx";

import { getDisplayType } from "../../util/orderApp.js";
import { getOrders, getOrderUser } from "../../api/orderApp.js";

import { PAGE_TYPE_ORDERS_LIST, PAGE_TYPE_DETAIL, GENERIC_ERROR_STRING } from "../../constants.js";

import "../../styles/orderApp.less";

export default function OrderApp() {
  const [path, setPath] = useState(window.location.hash);
  const [fetchError, setFetchError] = useState(false);
  /** @type {[OrdersListItem[], React.Dispatch<React.SetActionState<OrdersListItem[]>>]} */
  const [ordersList, setOrdersList] = useState([]);
  const [user, setUser] = useState({ firstName: "", lastName: "", sewperContactSeq: "" });
  const [loadingOrdersList, setLoadingOrdersList] = useState(false);

  //listen for hash changes to update path state
  useEffect(() => {
    window.onhashchange = () => {
      setPath(window.location.hash);
    };
  }, []);

  //update document title
  useEffect(() => {
    const { type, id } = getDisplayType(path);

    switch (type) {
      case PAGE_TYPE_ORDERS_LIST:
        document.title = "NASA SEWP Orders List";
        break;

      case PAGE_TYPE_DETAIL:
        document.title = `NASA SEWP ORDER - ${id}`;
        break;
    }
  }, [path]);

  useEffect(() => {
    setLoadingOrdersList(true);
    getOrderUser().then(({ data: user }) => {
      setUser({
                firstName: user.sewperContactFirst,
                lastName: user.sewperContactLast,
                sewperContactSeq: user.sewperContactSeq,
              });

      getOrders(user.sewperContactSeq)
      .then(({ data: ordersListResponse }) => {
        setOrdersList(ordersListResponse);
        setLoadingOrdersList(false);
      });
    }).catch(error => {
      setFetchError(error);
    });
  }, []);

  const display = getDisplayType(path);
  let content;

  if (fetchError) {
    content = <div>{GENERIC_ERROR_STRING}</div>;
  } else if (display.type === PAGE_TYPE_ORDERS_LIST) {
    content = <OrdersList loadingOrdersList={loadingOrdersList} ordersList={ordersList} user={user}/>;
  } else if (display.type === PAGE_TYPE_DETAIL) {
    content = <OrderDetail setFetchError={setFetchError} id={display.id} user={user}/>;
  } else {
    content = <div>Page not found.</div>;
  }

  return (<div id="order-app-wrapper" className="container-fluid">
    <h1 className="page_title" role="banner" tabIndex="-1">NASA SEWP Order Status</h1>
    {content}
  </div>);
}
